/*
 * Filename: d:\projects\AutoFiFront\src\Content\CarList\CarList.type.ts
 * Path: d:\projects\AutoFiFront
 * Created Date: Wednesday, January 25th 2023, 10:17:11 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import Config from "Config/Config";

class CarCost {
  public carCost = 0;
  public CustomText = "";

  public fromJson(jsonObj: any) {
    this.carCost = parseInt(jsonObj.InSell[0].SellPrice);
    this.CustomText = jsonObj.InSell[0].CustomText ?? "";
  }
}

class IconSubSection {
  IconSubSection = "";

  public fromJson(jsonObj: any) {
    this.IconSubSection = jsonObj.SubSection;
  }
}

class CarInfo {
  public Brand = "";
  public Model = "";
  public Version = "";
  public RegNb = "";
  public Mileage = 0;
  public CirculationDate: Date = new Date();
  public Gears = "";
  public Energy = "";
  public Status = "";
  public Fav = false;

  public fromJson(jsonObj: any) {
    this.Brand = jsonObj.Brand;
    this.Model = jsonObj.Model;
    this.Version = jsonObj.Version;
    this.RegNb = jsonObj.RegNb;
    this.Mileage = parseInt(jsonObj.InSell[0].Mileage);
    this.CirculationDate = new Date(jsonObj.CirculationDate);
    this.Fav = jsonObj.Favorites?.length > 0 ? true : false;
    this.Gears = jsonObj.Gears;
    this.Energy = jsonObj.Energy.Name;
    this.Status = jsonObj.InSell[0].Status;
  }
}

class CarImg {
  public url: string = Config.BACKEND.BASEURL + Config.BACKEND.PATHS.GET_PICTURE + `${1}`;
  public status = "";
  public subSection = "";

  public fromJson(jsonObj: any) {
    this.url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.GET_PICTURE}${jsonObj.id}`;
    this.status = jsonObj.InSell[0].Status;
    this.subSection = jsonObj.SubSection;
  }
}

export class CarListable {
  public id = "";
  public carCost: CarCost = new CarCost();
  public carInfo: CarInfo = new CarInfo();
  public iconSubSection: IconSubSection = new IconSubSection();
  public carImg: CarImg = new CarImg();

  public fromJson(jsonObj: any): void {
    this.id = jsonObj.id;
    this.carCost.fromJson(jsonObj);
    this.iconSubSection.fromJson(jsonObj);
    this.carInfo.fromJson(jsonObj);
    this.carImg.fromJson(jsonObj);
  }
}
